module.exports = __webpack_public_path__ + "img/signatureEle.ad6bec5f.svg";